import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Tooltip from '@mui/material/Tooltip';
import clsx from 'clsx';

export function ModuleChipAdornment({ hasMultipleInstances }: { hasMultipleInstances: boolean }) {
	const adornment = (
		<span className='relative -mr-1.25 ml-0.5 flex h-0 items-center'>
			{hasMultipleInstances && (
				<>
					<span className='w-1.25' />
					<AttachMoneyIcon
						className={clsx(
							'absolute top-1/2 left-1/2 -translate-x-[calc(50%+0.175rem)] -translate-y-1/2 scale-80 text-[oklch(from_currentcolor_calc(l*0.9)_calc(c*0.8)_h)]',
							'light:text-[oklch(from_currentcolor_calc(l*1.2)_calc(c*0.8)_h)]',
						)}
					/>
				</>
			)}
			<AttachMoneyIcon
				className='[--icon-color-base:--theme(--color-gray-1)]'
				style={
					hasMultipleInstances ?
						{
							filter:
								'drop-shadow(0px 0px 1px oklch(from var(--icon-color-base) l c h / 0.5))' +
								' drop-shadow(0px 0px 2px oklch(from var(--icon-color-base) l c h / 0.3))',
						}
					:	undefined
				}
			/>
		</span>
	);

	if (!hasMultipleInstances) {
		return adornment;
	}

	return <Tooltip title={<p>This module has multiple instances</p>}>{adornment}</Tooltip>;
}
